import { defineRouter } from '#q-app';
import { createMemoryHistory, createRouter, createWebHashHistory, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/stores/auth';
import routes from './routes';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

const createHistory = process.env.SERVER
  ? createMemoryHistory
  : process.env.VUE_ROUTER_MODE === 'history'
    ? createWebHistory
    : createWebHashHistory;

const Router = createRouter({
  scrollBehavior: () => ({ left: 0, top: 0 }),
  routes,

  // Leave this as is and make changes in quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  // quasar.conf.js -> build -> publicPath
  history: createHistory(process.env.VUE_ROUTER_BASE)
});

Router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
  const auth = useAuthStore();
  if (requiresAuth && !auth.token) next({ name: 'login' });
  else if (auth.token && to.name == 'login') next({ name: 'home' });
  else next();
});

// Router.onError((error, to) => {
//   if (error.message.includes('Failed to fetch dynamically imported module') || error.message.includes("Importing a module script failed")) {
//     window.location = to.fullPath
//   }
// })

export default defineRouter(function(/* { store, ssrContext } */) {
  return Router;
});

export { Router };
